export const APP_DEMO = {
  REQUEST_CANCEL_MSG: "Demo version of app. Cancelling."
};
